var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotice = function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notice_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M16.786 16.096h-.536v-7.59a6.25 6.25 0 0 0-5.357-6.184v-.869a.893.893 0 1 0-1.786 0v.869A6.25 6.25 0 0 0 3.75 8.507v7.59h-.536a.714.714 0 0 0-.714.713v.715c0 .098.08.178.179.178H7.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5h4.821a.18.18 0 0 0 .179-.178v-.714a.714.714 0 0 0-.714-.715M10 18.775c-.592 0-1.071-.48-1.071-1.072h2.142c0 .592-.48 1.072-1.071 1.072m-4.643-2.679v-7.59a4.6 4.6 0 0 1 1.36-3.283A4.6 4.6 0 0 1 10 3.864a4.6 4.6 0 0 1 3.284 1.36 4.6 4.6 0 0 1 1.359 3.283v7.59z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notice_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .385h20v20H0z"
  })))));
};
export default SvgNotice;